export const suites = [
  {
    name: 'デラックスルーム',
    description: '45㎡の空間に、和の繊細と現代の機能美が調和。窓辺に広がる東京の眺望とともに、穏やかな時をお過ごしください。',
    image: '/demo/hotel-site/images/suite-deluxe.png'
  },
  {
    name: 'ジュニアスイート',
    description: 'リビングと寝室を備えた70㎡のゆとり。お仕事の合間も、くつろぎの時も、自分らしく過ごせる空間です。',
    image: '/demo/hotel-site/images/suite-junior.png'
  },
  {
    name: 'プレジデンシャルスイート',
    description: '300㎡に広がる、東京を一望する至高の邸宅。専属バトラー、プライベートダイニング。ここにしかない、最上の体験を。',
    image: '/demo/hotel-site/images/suite-presidential.png'
  }
];